import { Outlet } from 'react-router-dom'

import {
    EnumExecutiveRoutes,
    EnumGlobalRoutes,
    ROUTE_TITLES_CONSTANT,
} from '../app/router/routerConstants'
import AnalysisIcon from '../assets/img/ico-analysis.svg?react'
import ChatIcon from '../assets/img/ico-chat.svg?react'
import FeedbackIcon from '../assets/img/ico-feedback.svg?react'
import GridsIcon from '../assets/img/ico-grids.svg?react'
import OrderIcon from '../assets/img/ico-order.svg?react'
import ReportIcon from '../assets/img/ico-report.svg?react'
import ToolsIcon from '../assets/img/ico-tools.svg?react'
import Header from '../compoments/layout/Header'
import Sidebar from '../compoments/layout/Sidebar'

const ExecutivesLayout = () => {
    const pages = [
        {
            icon: <GridsIcon />,
            title: ROUTE_TITLES_CONSTANT[EnumGlobalRoutes.DASHBOARD],
            url: EnumGlobalRoutes.DASHBOARD,
        },
        {
            icon: <ReportIcon />,
            title: ROUTE_TITLES_CONSTANT[
                EnumExecutiveRoutes.EXECUTIVES_PERFORMANCE_REPORTS
            ],
            url: EnumExecutiveRoutes.EXECUTIVES_PERFORMANCE_REPORTS,
        },
        {
            icon: <AnalysisIcon />,
            title: ROUTE_TITLES_CONSTANT[
                EnumExecutiveRoutes.EXECUTIVES_REVENUE_ANALYSIS
            ],
            url: EnumExecutiveRoutes.EXECUTIVES_REVENUE_ANALYSIS,
        },
        {
            icon: <OrderIcon />,
            title: ROUTE_TITLES_CONSTANT[EnumExecutiveRoutes.EXECUTIVES_KPI],
            url: EnumExecutiveRoutes.EXECUTIVES_KPI,
        },
        {
            icon: <ToolsIcon />,
            title: ROUTE_TITLES_CONSTANT[
                EnumExecutiveRoutes.EXECUTIVES_TECHNICIAN_PERFORMANCE
            ],
            url: EnumExecutiveRoutes.EXECUTIVES_TECHNICIAN_PERFORMANCE,
        },
        {
            icon: <FeedbackIcon />,
            title: ROUTE_TITLES_CONSTANT[
                EnumExecutiveRoutes.EXECUTIVES_CUSTOMER_FEEDBACK
            ],
            url: EnumExecutiveRoutes.EXECUTIVES_CUSTOMER_FEEDBACK,
        },
        {
            icon: <ChatIcon />,
            title: ROUTE_TITLES_CONSTANT[EnumGlobalRoutes.CHAT],
            url: EnumGlobalRoutes.CHAT,
        },
    ]

    return (
        <>
            <Header />
            <Sidebar pages={pages} />
            <div className="wrapper header-fixed sidebar-indentation">
                <Outlet />
            </div>
        </>
    )
}

export default ExecutivesLayout
